import { ReactNode } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { assetUrl } from '../../Shared/helpers';
import { useLocale } from '../../Shared/locale';
import { Card } from '../../Shared/UI/Card';
import { useRouter } from '../router';
import Container from '../UI/Container';
import Header from '../UI/Header';
import HeaderTitle from '../UI/HeaderTitle';
import Layout from '../UI/Layout';

export default function EmbedsPage() {
  const { t } = useTranslation();
  const { routes } = useRouter();
  const { locale } = useLocale();

  return (
    <div>
      <Header>
        <Container>
          <HeaderTitle>
            {t('backend:embeds')}
          </HeaderTitle>
          <Trans i18nKey="backend:embeds_description">
            <a href={`https://about.supporta.com/${locale}/contact`} target="_blank" rel="noopener noreferrer" />
          </Trans>
        </Container>
      </Header>

      <Container>
        <div className="grid grid-cols-3 gap-4">
          <Card
            link={{ href: routes.embed_campaign_overview_page(), ariaLabel: t('backend:campaign_overview_embed_title') }}
            spacing="none"
          >
            <div className="aspect-[2/1]">
              <img
                src={assetUrl('images/embed-campaign-overview.svg')}
                alt={t('backend:campaign_overview_embed_title')}
                className="rounded-t-xl"
              />
            </div>
            <div className="p-6">
              <h4 className="overflow-hidden whitespace-nowrap text-ellipsis">
                {t('backend:campaign_overview_embed_title')}
              </h4>
              <p>
                {t('backend:campaign_overview_embed_description')}
              </p>
            </div>
          </Card>
          <Card
            link={{ href: routes.embed_campaigns_count_page(), ariaLabel: t('backend:campaigns_count_embed_title') }}
            spacing="none"
          >
            <div className="aspect-[2/1]">
              <img
                src={assetUrl('images/embed-campaigns-count.svg')}
                alt={t('backend:campaigns_count_embed_title')}
                className="rounded-t-xl"
              />
            </div>
            <div className="p-6">
              <h4 className="overflow-hidden whitespace-nowrap text-ellipsis">
                {t('backend:campaigns_count_embed_title')}
              </h4>
              <p>
                {t('backend:campaigns_count_embed_description')}
              </p>
            </div>
          </Card>
          <Card
            link={{ href: routes.embed_funds_raised_page(), ariaLabel: t('backend:funds_raised_embed_title') }}
            spacing="none"
          >
            <div className="aspect-[2/1]">
              <img
                src={assetUrl('images/embed-funds-raised.svg')}
                alt={t('backend:funds_raised_embed_title')}
                className="rounded-t-xl"
              />
            </div>
            <div className="p-6">
              <h4 className="overflow-hidden whitespace-nowrap text-ellipsis">
                {t('backend:funds_raised_embed_title')}
              </h4>
              <p>
                {t('backend:funds_raised_embed_description')}
              </p>
            </div>
          </Card>
        </div>
      </Container>
    </div>
  );
}

EmbedsPage.layout = (page: ReactNode) => <Layout>{page}</Layout>;
